import { CheckIcon, XIcon } from "./Icons";
import searchIcon from "../assets/icons/searchIcon.svg";
import { useEffect, useState } from "react";
import { useListLinkServiceNear } from "../hooks/useListLinkServiceNear";
import { useForm } from "react-hook-form";
import { ListLinkServiceNearQuery } from "../hooks/useListLinkServiceNear";
import { isLoggedInVar, serviceId, serviceIsActive, serviceName } from "../apollo";
import { useApolloClient, useReactiveVar } from "@apollo/client";
import {
  ListBasketItemServiceInput,
  ListBasketItemServiceQuery,
} from "../gql/graphql";
import { useListBasketItemService } from "../hooks/useListBasketItemService";
import { ConfirmComponent } from "./alert";
import { Dialog } from "@mui/material";
import { GetLinkServiceNearQuery } from "../hooks/useGetLinkServiceNear";
import { useDelBaksetItem } from "../hooks/useDelBasketItem";

interface ListRegionProps {
  listRegionOpen: boolean;
  setListRegionOpen: (open: boolean) => void;
}

export const ListRegion: React.FC<ListRegionProps> = ({
  listRegionOpen,
  setListRegionOpen,
}) => {
  const client = useApolloClient();
  // 현재 좌표
  const [navLocatoin, setNavLocation] = useState(true);
  navigator.geolocation.getCurrentPosition(
    (position) => {
      setLatitude(position.coords.latitude);
      setLongitude(position.coords.longitude);
    },
    (error) => {
      console.error("위치 가져오기 실패:", error);
      setNavLocation(false);
    },
    {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0,
    }
  );

  const { handleSubmit, getValues, register } = useForm();
  // 서비스 지역 ID
  const listRegion_serviceId = useReactiveVar(serviceId);
  // 원본 데이터와 필터링된 데이터를 분리
  const [originalServiceList, setOriginalServiceList] = useState<
    ListLinkServiceNearQuery["listLinkServiceNear"]["linkservice"]
  >([]);
  const [filteredServiceList, setFilteredServiceList] = useState<
    ListLinkServiceNearQuery["listLinkServiceNear"]["linkservice"]
  >([]);

  // 서비스 지역 데이터 조회 및 정렬
  const onCompleted = (data: ListLinkServiceNearQuery) => {
    console.log(data, "data");
    const list = data.listLinkServiceNear.linkservice;
    const listWithServiceId = [...list].sort((a, b) => {
      if (Number(a.id) === Number(listRegion_serviceId)) {
        return -1;
      }
      return 1;
    });

    // 원본 데이터 저장
    setOriginalServiceList(listWithServiceId);
    // 초기에는 필터링된 리스트도 전체 데이터로 설정
    setFilteredServiceList(listWithServiceId);
  };

  const [listLinkServiceNear] = useListLinkServiceNear(onCompleted);
  const [latitude, setLatitude] = useState(36.12316);
  const [longitude, setLongitude] = useState(128.184984);

  const listLinkServiceHandler = () => {
    listLinkServiceNear({
      variables: {
        input: {
          latitude: latitude,
          longitude: longitude,
        },
      },
    });
  };

  useEffect(() => {
    listLinkServiceHandler();
  }, [latitude, longitude]);

  // 검색
  const searchHandler = () => {
    const search = getValues("search");

    if (!search || search.trim() === "") {
      // 검색어가 없으면 원본 데이터 전체 표시
      setFilteredServiceList(originalServiceList);
    } else {
      // 원본 데이터에서 검색
      const filtered = originalServiceList.filter((service) =>
        service.name?.toLowerCase().includes(search.toLowerCase().trim())
      );
      setFilteredServiceList(filtered);
    }
  };

  // 거리 표시
  const showDistance = (distance: number) => {
    // km 표시 , 소수점 두자리까지 100km 이상이면 소수점 표시 X
    const distanceKm = distance / 1000;
    if (distanceKm < 100) {
      return `${distanceKm.toFixed(2)}km`;
    } else {
      return `${distanceKm.toFixed(0)}km`;
    }
  };

  // 지역 변경, 장바구니 물품 확인
  const [serviceRegionToChange, setServiceRegionToChange] = useState<
    GetLinkServiceNearQuery["getLinkServiceNear"]["linkservice"]
  >({
    id: "",
    name: "",
    description: "",
    latitude: 0,
    longitude: 0,
    address: "",
    distance: 0,
    isActive: true,
  });
  const [serviceBaksetIds, setServiceBaksetIds] = useState<number[]>([]);
  const [delBasketItem] = useDelBaksetItem();
  const removeBasketItemHandler = async () => {
    try {
      await delBasketItem({
        variables: { input: { basketItemIds: serviceBaksetIds } },
      });
      client.cache.modify({
        fields: {
          listBasketItem(existingData) {
            return {
              ...existingData,
              basketItems: [],
            };
          },
        },
      });
    } catch (error) {
      console.log(error);
      alert(" 오류가 발생했습니다.");
    }
  };
  const [basketClearModal, setBasketClearModal] = useState(false);
  const changeRegionHandler = (
    service: GetLinkServiceNearQuery["getLinkServiceNear"]["linkservice"]
  ) => {
    if (service.id) {
      console.log(service.isActive);
      serviceId(Number(service.id));
      serviceName(service.name || "");
      serviceIsActive(service.isActive);
      setListRegionOpen(false);
    } else {
      alert("변경 중 오류가 발생했습니다.");
      setListRegionOpen(false);
    }
  };
  // 장바구니 물품 확인
  const onListBasketItemService = async (data: ListBasketItemServiceQuery) => {
    const {
      listBasketItemService: { ok, err, basketItems },
    } = data;
    if (ok && basketItems && basketItems.length > 0) {
      setBasketClearModal(true);
      setServiceBaksetIds(basketItems.map((item) => item.id));
    } else {
      changeRegionHandler(serviceRegionToChange);
    }
  };

  const [
    listBasketItemService,
    { data, loading: listBasketItemServiceLoading, refetch },
  ] = useListBasketItemService(onListBasketItemService);
  const listBasketItemServiceHandler = (serviceId: number) => {
    const input: ListBasketItemServiceInput = {
      serviceId,
    };
    listBasketItemService({ variables: { input } });
  };

  return (
    <div className="w-[80vw] h-[70vh] min-h-[400px] max-w-[600px] overflow-y-auto rounded-md bg-bg">
      <div className="modalHeader relative py-2 border-b border-grayFont px-2 bg-white">
        <button
          className="absolute top-1/2 -translate-y-1/2 left-2"
          onClick={() => setListRegionOpen(false)}
        >
          <XIcon width={24} height={24} />
        </button>
        <p className="font-bold text-center">서비스 지역 선택</p>
      </div>
      <div className="h-12 relative flex flex-wrap content-center justify-center px-5 bg-white">
        <form onSubmit={handleSubmit(searchHandler)} className="relative">
          <input
            type="text"
            className="w-full h-8 rounded-md bg-white border border-black pl-4 pr-10 text-small break:text-standard placeholder:text-grayFont"
            placeholder="배달 받을 곳을 검색해보세요."
            {...register("search", { onChange: searchHandler })}
          />
          <button
            type="submit"
            className="absolute right-2 top-[10px]"
            onClick={() => searchHandler()}
          >
            <img src={searchIcon} alt="검색 버튼" />
          </button>
        </form>
      </div>
      {!navLocatoin && (
        <div className="relative flex flex-wrap content-center justify-center px-5 py-2 bg-white">
          <p className="text-sm text-red-400 font-bold">
            위치 정보를 허용하면 정확한 정보를 알 수 있어요.
          </p>
        </div>
      )}
      <div className="mt-2 pb-10 bg-white px-3">
        {filteredServiceList &&
          filteredServiceList.map((service, index) => (
            <div
              key={`service-region-${index}`}
              onClick={() => {
                setServiceRegionToChange(service);
                if (isLoggedInVar()) {
                  listBasketItemServiceHandler(listRegion_serviceId);
                } else {
                  changeRegionHandler(service);
                }
              }}
              className={`listCard flex gap-2 pt-2 pb-4 border-t border-block cursor-pointer ${
                index === 0 && "border-t-0"
              }`}
            >
              <div className="flex-1 flex flex-col gap-1 ">
                <div
                  className={`title font-bold ${
                    service.isActive ? "" : "text-block"
                  }`}
                >
                  {service.name}

                  <span className="inline-block align-top ml-2">
                    {Number(service.id) === Number(listRegion_serviceId) && (
                      <CheckIcon size={18} />
                    )}
                  </span>
                  {service.isActive === false && (
                    <span className="inline-block text-xs text-black ml-2 border border-black rounded-full px-1 py-0.5">
                      지금은 닫혀있어요!
                    </span>
                  )}
                </div>
                <p
                  className={`text-sm  ${
                    service.isActive ? "text-grayFont" : "text-block"
                  }`}
                >
                  {service.description}
                </p>
                <p
                  className={`text-sm ${service.isActive ? "" : "text-block"}`}
                >
                  {service.address}
                </p>
              </div>
              <div className="flex flex-wrap content-center gap-1">
                <span className="text-lg text-mainIcon font-bold">
                  {showDistance(service.distance)}
                </span>
              </div>
            </div>
          ))}
      </div>
      <Dialog
        open={basketClearModal}
        onClose={() => {
          setBasketClearModal(false);
        }}
      >
        <ConfirmComponent
          desc="서비스 지역을 변경하면 현재 지역의 장바구니 물품이 사라집니다.
        변경하시겠습니까?"
          closeFunction={() => {
            setBasketClearModal(false);
          }}
          confirmFunction={() => {
            changeRegionHandler(serviceRegionToChange);
            removeBasketItemHandler();
          }}
        />
      </Dialog>
    </div>
  );
};
